import { createContext } from 'react';
import packageJson from '../../package.json';

type DefaultProps = {
    children: React.ReactNode,
};

export const appVersion = process.env.REACT_APP_PREFIX + "-" + packageJson.version;

export const AppVersionContext = createContext({
    appVersion: appVersion
});

export default function AppVersionProvider(props: DefaultProps) {

    return (
        <AppVersionContext.Provider value={{appVersion}}>
            {props.children}
        </AppVersionContext.Provider>
    );
}
